module.exports = __webpack_public_path__ + "img/kuwait.98d6e240.svg";